import React, { useEffect, useState } from "react";
import EmptyData from "../../EmptyData";
import LoadingSpinner from "../../Loading/LoadingSpinner";

const Products = () => {
  const [products, setProducts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const getProducts = async () => {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_TIPSY_URL}/api/products`,
      {
        method: "GET",
      }
    );
    const result = await response.json();
    setProducts(result.products);
    setIsLoading(false);
  };

  useEffect(() => {
    getProducts();
  }, []);
  return !isLoading ? (
    <div
      id="products"
      className="flex min-h-[calc(100vh-56px)] flex-col items-center bg-black text-[#ffb700] transition-all duration-500"
    >
      <div className="relative flex flex-col items-center justify-center">
        <img
          src={`${process.env.REACT_APP_IMAGES_URL}/Assets/Images/E-Commerces/Tipsy/empty-monkey.png`}
          alt="empty monkey"
          className="w-80 ss:w-96"
        />
        <h1 className="absolute text-2xl font-semibold ss:text-3xl">
          Our <span className="text-white">Products</span>
        </h1>
      </div>
      {products?.length > 0 ? (
        <div className="my-5 flex flex-wrap items-center justify-center">
          {products.map((product) => (
            <div
              key={product._id}
              className="m-5 flex min-h-[450px] w-full flex-col rounded-lg shadow-[0_5px_5px_5px_#3331] xs:min-h-[600px] xs:w-80 ss:w-96"
            >
              <img
                src={`${process.env.REACT_APP_BACKEND_TIPSY_URL}/${product.image[0]}`}
                alt="product"
                className="mb-3 w-full rounded-t-lg object-cover xs:w-80 ss:w-96"
              />
              <div className="flex items-center justify-between px-2">
                <h1 className="text-xl font-semibold">{product.name}</h1>
                <p>${product.price}</p>
              </div>
              <p className="mt-3 w-full px-2 text-sm font-thin text-white xs:mt-5 xs:text-base ss:w-80">
                {product.description}
              </p>
              {product.countInStock !== 0 ? (
                <p className="mt-2 mr-2 mb-2 self-end rounded-2xl border-2 border-green-500 px-2 text-sm font-bold text-green-500 xs:mt-auto xs:text-base">
                  Available
                </p>
              ) : (
                <p className="mt-2 mr-2 mb-2 self-end rounded-2xl border-2 border-red-500 px-2 text-sm font-bold text-red-500 xs:mt-auto xs:text-base">
                  Out Of Stock
                </p>
              )}
            </div>
          ))}
        </div>
      ) : (
        <EmptyData message="No Products Available now" />
      )}
    </div>
  ) : (
    <LoadingSpinner
      name="Products"
      bgColor="black"
      text="white"
      isLight={false}
    />
  );
};

export default Products;
